import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { Transaction } from 'functions/src/types/firestore/Game/Collection/Item/Transaction';
import { useCurrency } from 'src/contexts/CurrencyContext';
import { CryptoChain } from 'src/util/CryptoChain';
import { truncate } from 'src/util/truncate';
import { GradientTypography } from '../gradients/GradientTypography';

export type TransactionRowDescriptionProps = {
  transaction: Transaction<Date>;
};
//TODO: refactor once purchase/mint have item title
export const TransactionRowDescription = ({
  transaction,
}: TransactionRowDescriptionProps) => {
  const theme = useTheme();
  const { type, toAddress, price } = transaction;
  const { formatFiat, formatCrypto } = useCurrency();

  const cryptoSymbol = CryptoChain.from(transaction?.contract?.chainId).coin;
  // eslint-disable-next-line @blumintinc/blumint/extract-global-constants
  const convertPrice = (n: number) => {
    //currency.currencyOptions.currency.name
    return `${formatCrypto({
      wei: n,
      cryptocurrency: cryptoSymbol,
    })} (${formatFiat({ wei: n, cryptocurrency: cryptoSymbol })})`;
  };
  switch (type) {
    case 'purchase':
      return (
        <Box
          sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
        >
          <Typography sx={{ mx: 0.5, color: theme.palette.text.secondary }}>
            sold to
          </Typography>
          <Typography sx={{ mx: 0.5 }}>{`${truncate(to.address)}`}</Typography>
          <Typography sx={{ mx: 0.5, color: theme.palette.text.secondary }}>
            for
          </Typography>
          <GradientTypography
            variant="body1"
            gradientColor="success.horizontal"
            sx={{ mx: 0.5 }}
          >{`${convertPrice(price || 0)}`}</GradientTypography>
        </Box>
      );
    case 'mint':
      return (
        <Box
          sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
        >
          <Typography sx={{ mx: 0.5 }}>minted item</Typography>
          {/* TODO: re-introduce title once we have a reliable way
          of getting the item title */}
          {/* <Typography
            sx={{ mx: 0.5 }}
          >{`${transaction?.attributes?.item?.attributes?.title}`}</Typography> */}
        </Box>
      );
    case 'bid':
      return (
        <Box
          sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
        >
          <Typography sx={{ mx: 0.5, color: theme.palette.text.secondary }}>
            placed bid for
          </Typography>
          <Typography
            sx={{ mx: 0.5, color: theme.palette.info.main }}
          >{` ${convertPrice(price || 0)}`}</Typography>
          .
        </Box>
      );
    case 'transfer':
      return (
        <Box
          sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
        >
          <Typography sx={{ mx: 0.5 }}>transferred to</Typography>
          <Typography sx={{ mx: 0.5 }}>
            {truncate(toAddress || transaction?.to?.address)}
          </Typography>
          .
        </Box>
      );
    case 'fulfillmentRental':
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          <Typography
            sx={{ ml: 1, mr: 0.5, color: theme.palette.text.secondary }}
          >
            rented this item from
          </Typography>
          <Typography sx={{ mx: 0.5 }}>{`${truncate(
            toAddress || transaction?.to?.address,
          )}`}</Typography>
          {/* <GradientTypography
            variant="body1"
            gradientColor="primary.vertical"
            sx={{ mx: 0.5 }}
          >{`${transaction?.attributes?.item?.attributes?.title}`}</GradientTypography> */}
          <Typography sx={{ mx: 0.5, color: theme.palette.text.secondary }}>
            for
          </Typography>
          <GradientTypography
            variant="body1"
            gradientColor="royal.vertical"
            sx={{ mx: 0.5 }}
          >
            {convertPrice(price || 0)}
          </GradientTypography>
          .
        </Box>
      );
    default:
      return <Box>I should not exist</Box>;
  }
};
